/* eslint max-len: 0 */
import React, { FC } from 'react';
import { SvgComponentProps } from './types';
import { Svg } from './Svg';

const ModFormBuilder: FC<SvgComponentProps> = (props) => {
	return (
		<Svg {...props}>
			<path
				fillRule='evenodd'
				clipRule='evenodd'
				d='M2 0C0.895431 0 0 0.895431 0 2V14C0 15.1046 0.895431 16 2 16H14C15.1046 16 16 15.1046 16 14V2C16 0.895431 15.1046 0 14 0H2ZM7 2H3V3H7V2ZM13 14H3V13H13V14ZM3 12H13V11H3V12ZM13 10H3V9H13V10ZM3 8H13V7H3V8ZM13 6H3V5H13V6ZM9 3H13V2H9V3Z'
			/>
		</Svg>
	);
};

export { ModFormBuilder };
